import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  getMediaTypeForQid,
  getVideoPreview,
  getIsClpDownloadEnabled
} from '../../redux/modules/campaignLandingPage';
import DownloadButton from './DownloadButton';
import PostRecordingActions from './PostRecordingActions';
import CodecWarning from './CodecWarning';
import styles from './VideoPreview.module.less';

const VideoPreview = ({
  mediaType,
  videoPreview,
  qid,
  isClpDownloadEnabled,
  createMediaSubmissionFn,
}) => {
  if (!videoPreview) {
    return null;
  }

  return (
    <section className={styles.vpPreviewContainer}>
      <video
        className={styles.vpVideoPreview}
        controls
        key={videoPreview}
        controlsList={isClpDownloadEnabled ? '' : 'nodownload'}
      >
        <source src={videoPreview} type={mediaType} />
        <source src={videoPreview} />
      </video>
      <CodecWarning mediaType={mediaType} />
      <PostRecordingActions
        qid={qid}
        createMediaSubmissionFn={createMediaSubmissionFn}
      />
      {isClpDownloadEnabled && <DownloadButton mediaBlobUrl={videoPreview} qid={qid} />}
    </section>
  );
};

VideoPreview.propTypes = {
  mediaType: PropTypes.string,
  createMediaSubmissionFn: PropTypes.func,
  videoPreview: PropTypes.string,
  qid: PropTypes.string,
  isClpDownloadEnabled: PropTypes.bool
};

function mapStateToProps(state, ownProps) {
  return {
    videoPreview: getVideoPreview(state, ownProps.qid),
    mediaType: getMediaTypeForQid(state, ownProps.qid),
    isClpDownloadEnabled: getIsClpDownloadEnabled(state)
  };
}

export default connect(mapStateToProps)(VideoPreview);



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/VideoPreview.jsx